/*!
 * Copyright © 2026. Verizon Connect Ireland Limited. All rights reserved.
 */

export const AccountFeatureToggle = {
  CentralizedAccountHubEnabled: 'CentralizedAccountHubEnabled',
} as const;

export type AccountFeatureToggleName = (typeof AccountFeatureToggle)[keyof typeof AccountFeatureToggle];
